module.exports = __webpack_public_path__ + "static/media/kidmania.b1d65d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/kidmania.png
// module id = 415
// module chunks = 0